<template>
  <div class="student-select position-relative d-flex w-100">
    <eg-b-overlay :show="studentLoading" no-wrap>
      <template #overlay>
        <eg-b-spinner small variant="info" />
      </template>
    </eg-b-overlay>
    <filter-select
      v-if="!studentLoading"
      :items="allStudents"
      :value="value"
      :settings="settings"
      :value-is-id="false"
      :placeholder="placeholder"
      @input="selectStudent"
    />
  </div>
</template>

<script>
import { getStudents } from "@/api";
import FilterSelect from "@/components/filter-select";

export default {
  components: {
    FilterSelect,
  },

  props: {
    value: {
      type: [Object, Number, Array],
      default: null,
    },

    valueIsId: {
      type: Boolean,
      default: false,
    },

    students: {
      type: Array,
      default: () => [],
    },

    size: {
      type: String,
      default: "md",
    },

    placeholder: {
      type: String,
      default: "Search",
    },

    allowDeselect: {
      type: Boolean,
      default: false,
    },

    autoSelectFirst: {
      type: Boolean,
      default: false,
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      studentLoading: false,
      allStudents: [],
    };
  },

  computed: {
    selectedStudent() {
      return this.valueIsId
        ? this.allStudents.find((c) => c.id === this.value)
        : this.value;
    },
  },

  watch: {
    "$route.params.id"() {
      this.init();
    },
  },

  async created() {
    this.init();
  },

  methods: {
    selectStudent(studentData) {
      if (Array.isArray(studentData)) {
        this.$emit(
          "input",
          studentData.map((student) => student.id)
        );
      } else {
        this.$emit("input", studentData);
      }
    },

    async fetchStudents() {
      this.studentLoading = true;
      try {
        const { data } = await getStudents({
          folderId: +this.$route.params.id,
          limit: 1000,
        });

        this.allStudents = data.rows.map(({ id, firstName, lastName }) => ({
          id,
          firstName,
          lastName,
          name: `${firstName} ${lastName || ""}`,
        }));

        if (this.autoSelectFirst && this.allStudents.length > 0) {
          this.selectStudent(this.allStudents[0]);
        }

        this.studentLoading = false;
      } catch (error) {
        this.studentLoading = false;
        this.$showToastError(error.response?.data?.error);
      }
    },

    init() {
      if (this.students.length > 0) {
        return (this.allStudents = this.students);
      }

      this.fetchStudents();
    },
  },
};
</script>

<style lang="scss" scoped>
.student-select {
  min-height: 80px;
}

.dropdown-item-wrapper {
  &::v-deep {
    .dropdown-item {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
